import React, { createContext, useContext, useState, useMemo } from 'react';

const UIContext = createContext(null);

export const useUI = () => {
    const context = useContext(UIContext);
    if (!context) {
        throw new Error('useUI must be used within UIProvider');
    }
    return context;
};

export const UIProvider = ({ children }) => {
    const [showDarkBackground, setShowDarkBackground] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    const value = useMemo(() => ({
        showDarkBackground,
        setShowDarkBackground,
        sidebarCollapsed,
        setSidebarCollapsed
    }), [showDarkBackground, sidebarCollapsed]);

    return (
        <UIContext.Provider value={value}>
            {children}
        </UIContext.Provider>
    );
};

